import { Injectable } from '@angular/core';
import { HttpErrorHandlerService } from '../http-error-handler.service';
import { HttpService } from '../http.service';
import { Observable, catchError, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  constructor(
    private httpService: HttpService,
    private errorHandler: HttpErrorHandlerService
  ) { }

  /**
   * Obtiene el precio a pagar
   * @returns Observable con los datos de la cuenta
   */
  getPaymentAmount(articleId:number): Observable<any> {
    return this.httpService.get(`payment/amount/${articleId}`).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  checkoutSession(articleId: number, data?: any): Observable<any> {
    return this.httpService.post(`payment/checkout-session/${articleId}`, data || {}).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  /**
   * Crea una intención de pago con Stripe
   * @param params Datos necesarios para la intención de cargo (precio, etc.)
   * @returns Observable con la respuesta del servidor que incluye los datos de la intención de pago
   */
  chargeIntent(data: any): Observable<any> {
    return this.httpService.post(`payment/charge-intent`, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

}
